import { GetterTree } from 'vuex'

import { RootState, ChainStoreState } from '@/types/store'

export interface ChainStoreGetters
  extends GetterTree<ChainStoreState, RootState> {
  chainStores: (state: ChainStoreState) => ChainStoreState['chainStores']
}

export const getters: ChainStoreGetters = {
  chainStores(state): ChainStoreState['chainStores'] {
    return state.chainStores.filter(cs => cs.ng_flag === false)
  },
  allChainStores(state): ChainStoreState['chainStores'] {
    return state.chainStores
  },
}
